"use client";

import { useContextSelector } from "use-context-selector";
import { PreferencesStoreContext } from "./store";
import type { AnimationPreferences } from "./types";

export function useAnimationPreferences() {
    const updatePreferences = useContextSelector(PreferencesStoreContext, (s) => s?.updatePreferences);
    const animationPreferences = useContextSelector(PreferencesStoreContext, (s) => s?.preferences.accessibility.animation as AnimationPreferences);

    const updateAnimationPreferences = async (partial: Partial<AnimationPreferences>) => {
        await updatePreferences((prev) => ({
            ...prev,
            accessibility: { ...prev.accessibility, animation: { ...prev.accessibility.animation, ...partial } },
        }));
    };

    const replaceAnimationPreferences = async (next: AnimationPreferences) => {
        await updatePreferences((prev) => ({
            ...prev,
            accessibility: { ...prev.accessibility, animation: next },
        }));
    };

    return { animationPreferences, updateAnimationPreferences, replaceAnimationPreferences };
}